import { call, put } from 'redux-saga/effects';
import { api, showErrorNotification } from '@med-fe/util';
import {
  fetchEmailGroupsFailed,
  fetchEmailGroupsSuccess,
  fetchUserEmailGroupsFailed,
  fetchUserEmailGroupsSuccess,
  updateUserEmailGroupsSuccess,
  updateUserEmailGroupsFailed,
  FETCH_TAB_VISIBILITY_SUCCESS,
  FETCH_TAB_VISIBILITY_FAILED,
  fetchAdminEmailsSuccess,
  fetchAdminEmailsFailed,
  fetchUserPositionsSuccess,
  fetchUserPositionsFailed,
} from './user-actions';

export function* fetchUserEmailGroupsStartWorker({ payload }): Generator {
  try {
    const url = `/emails/${payload}/groups`;
    const data = yield call(api.get, url);
    yield put(fetchUserEmailGroupsSuccess(data));
  } catch (e) {
    yield put(fetchUserEmailGroupsFailed(e));
    showErrorNotification(null, e);
  }
}

export function* fetchEmailGroupsStartWorker(): Generator {
  try {
    const url = `/emails/groups`;
    const data = yield call(api.get, url);
    yield put(fetchEmailGroupsSuccess(data));
  } catch (e) {
    yield put(fetchEmailGroupsFailed(e));
    showErrorNotification(null, e);
  }
}

export function* fetchAdminEmailsStartWorker(): Generator {
  try {
    const url = `/emails/admins`;
    const data = yield call(api.get, url);
    yield put(fetchAdminEmailsSuccess(data));
  } catch (e) {
    yield put(fetchAdminEmailsFailed(e));
    showErrorNotification(null, e);
  }
}

export function* updateUserEmailGroupsStartWorker({ payload }): Generator {
  try {
    const url = `/emails`;
    const data: any = yield call(api.post, url, payload);
    yield put(updateUserEmailGroupsSuccess(data));
  } catch (e) {
    yield put(updateUserEmailGroupsFailed(e));
    showErrorNotification(null, e);
  }
}

export function* fetchTabVisibilityWorker({ payload }): Generator {
  try {
    const url = '/access/visibility';
    const data: any = yield call(api.post, url, payload);

    yield put({ type: FETCH_TAB_VISIBILITY_SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: FETCH_TAB_VISIBILITY_FAILED, error: e });
  }
}

export function* fetchUserPositionsStartWorker({ payload }): Generator {
  try {
    const url = `/employee/positions/${payload}`;
    const data = yield call(api.get, url, true, true);
    yield put(fetchUserPositionsSuccess(data));
  } catch (e) {
    console.log(e, 'error--');
    yield put(fetchUserPositionsFailed(e));
    showErrorNotification(null, e);
  }
}
